import type { IProductItem } from './config';

export const productsUltra: Record<string, IProductItem[]> = {
    eu: [
        {
            variantId: '50510963016023',
            name: 'EcoFlow STREAM Ultra',
            tips: '',
            desc: '1 × EcoFlow STREAM Ultra (1,92 kWh)',
            save: 'Capacity: 1.92kWh',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50396945482071&purchaseOption=691099697495',
            descList: ['2,300W', '2,000W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50511267955031',
            name: 'EcoFlow STREAM Ultra Set (1.040Wp)',
            tips: '',
            desc: '2 × 520W Rigid Solar Panels + 1 × EcoFlow STREAM Ultra (1.92 kWh)',
            save: 'Saving up to €385 per year',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703172439&purchaseOption=691099697495',
            descList: ['97%', '992kWh', '989 kg'],
        },
        {
            variantId: '50245703237975',
            name: 'EcoFlow STREAM Advanced Set (2.080Wp)',
            tips: 'Ideal for 90–119m² Home Size',
            desc: '4 × 520W Rigid Solar Panels + 1 × EcoFlow STREAM Ultra (1.92 kWh) + 2 × EcoFlow STREAM AC Pro (1,92 kWh)',
            save: 'Saving up to €761 per year',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703139671&purchaseOption=691099697495',
            descList: ['96%', '1,983kWh', '1,977 kg'],
        },
    ],
    uk: [
        {
            variantId: '50839891116371',
            name: 'EcoFlow STREAM Ultra',
            desc: '1 × EcoFlow STREAM Ultra (1.92 kWh)',
            tips: '',
            save: 'Capacity: 1.92kWh',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50758705021267&purchaseOption=690042765651',
            descList: ['2,300W', '2,000W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50839891181907',
            name: 'EcoFlow STREAM Ultra Set (1040Wp)',
            desc: '2 × 520W Rigid Solar Panels + 1 × EcoFlow STREAM Ultra (1.92 kWh)',
            tips: '',
            save: 'Saving up to £289 per year',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613836627&purchaseOption=690042765651',
            descList: ['97%', '992kWh', '989 kg'],
        },
        {
            variantId: '50633613902163',
            name: 'EcoFlow STREAM Advanced Set (2080Wp)',
            desc: '4 × 520W Rigid Solar Panels + 1 × EcoFlow STREAM Ultra (1.92 kWh) + 2 × EcoFlow STREAM AC Pro (1.92 kWh)',
            tips: '',
            save: 'Saving up to £571 per year',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613803859&purchaseOption=690042765651',
            descList: ['96%', '1,983kWh', '1,977 kg'],
        },
    ],
    de: [
        {
            variantId: '55835416199549',
            name: 'EcoFlow STREAM Ultra',
            desc: '1 × EcoFlow STREAM Ultra (1 920 Wh)',
            tips: '',
            save: 'Kapazität: 1,92kWh',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55738978959741&purchaseOption=710509658493',
            descList: ['2 300 W', '2 000 W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '55835416265085',
            name: 'EcoFlow STREAM Basic Set (1 040 Wp)',
            desc: '2 × 520 W Starres Solarpanel + 1 × EcoFlow STREAM Ultra (1 920 Wh)',
            tips: '',
            save: 'Bis zu 385 € Ersparnis pro Jahr',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410618749&purchaseOption=710509658493',
            descList: ['97 %', '992 kWh', '989 kg'],
        },
        {
            variantId: '55583410684285',
            name: 'EcoFlow (1 920 Wh × 3) STREAM Serie Advanced Set (2 080 Wp)',
            desc: '4 × 520 W Starres Solarpanel + 1 × EcoFlow STREAM Ultra (1 920 Wh) + 2 × EcoFlow STREAM AC Pro (1 920 Wh)',
            tips: '',
            save: 'Bis zu 761 € Ersparnis pro Jahr',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410585981&purchaseOption=710509658493',
            descList: ['96 %', '1 983 kWh', '1 977 kg'],
        },
    ],
    fr: [
        {
            variantId: '50473938420059',
            name: 'EcoFlow STREAM Ultra',
            desc: '1 × EcoFlow STREAM Ultra (1 920 Wh)',
            tips: '',
            save: `Capacité : 1,92kWh`,
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50393675891035&purchaseOption=693334770011',
            descList: ['2 300W', '2 000W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50473938485595',
            name: 'Kit de base EcoFlow STREAM (1 040 Wc)',
            desc: '2 panneaux solaires rigides 520 W + 1 × EcoFlow STREAM Ultra (1 920 Wh)',
            tips: '',
            save: 'Économisez jusqu’à 275 € par an',
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857093467&purchaseOption=693334770011',
            descList: ['97 %', '1 420 kWh', '989 kg'],
        },
        {
            variantId: '50286857159003',
            name: 'Kit avancé EcoFlow (1 920 Wh × 3) STREAM (2 080 Wc)',
            desc: '4 panneaux solaires rigides 520 W + 1 × EcoFlow STREAM Ultra (1 920 Wh) + 2 EcoFlow STREAM AC Pro (1 920 Wh)',
            tips: '',
            save: 'Économisez jusqu’à 545 € par an',
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857060699&purchaseOption=693334770011',
            descList: ['96 %', '2 840 kWh', '1 977 kg'],
        },
    ],
    it: [
        {
            variantId: '55029709537656',
            name: 'EcoFlow STREAM Ultra',
            desc: '1 × EcoFlow STREAM Ultra (1.920 Wh)',
            tips: '',
            save: 'Capacità: 1,92kWh',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=55011791634808&purchaseOption=710883574136',
            descList: ['2.300W', '2.000W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '55029709603192',
            name: 'Set di base EcoFlow STREAM (1.040 Wp)',
            desc: '2 pannelli solari rigidi da 520 W + 1 × EcoFlow STREAM Ultra (1.920 Wh)',
            tips: '',
            save: 'Un risparmio che può raggiungere 289 €',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832328568&purchaseOption=710883574136',
            descList: ['97 %', '992 kWh', '989 kg'],
        },
        {
            variantId: '54987832394104',
            name: 'Set avanzato serie EcoFlow STREAM (1.920 Wh × 3) (2.080 Wp)',
            desc: '4 pannelli solari rigidi da 520 W + 1 × EcoFlow STREAM Ultra (1.920 Wh) + 2 EcoFlow STREAM AC Pro (1.920 Wh)',
            tips: '',
            save: 'Un risparmio che può raggiungere 571 € l’anno',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832295800&purchaseOption=710883574136',
            descList: ['96%', '1.983 kWh', '1.977 kg'],
        },
    ],
    es: [
        {
            variantId: '50473803383131',
            name: 'EcoFlow STREAM Ultra',
            desc: '1 × EcoFlow STREAM Ultra (1920 Wh)',
            tips: '',
            save: 'Capacidad: 1,92 kWh',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50393711870299&purchaseOption=693334802779',
            descList: ['2.300 W', '2.000 W', 'IP65'],
            noPanels: true,
        },
        {
            variantId: '50473803448667',
            name: 'Set EcoFlow STREAM Basic (1040 Wp)',
            desc: '2 paneles solares rígidos de 520 W + 1 × EcoFlow STREAM Ultra (1920 Wh)',
            tips: '',
            save: 'Ahorra hasta 144 € cada año',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854832475&purchaseOption=693334802779',
            descList: ['97%', '992 kWh ', '989 kg'],
        },
        {
            variantId: '50286854898011',
            name: 'Set EcoFlow STREAM Serie Advanced (3 de 1920 Wh) (2080 Wp)',
            desc: '4 Paneles solares rígidos de 520 W + 1 × EcoFlow STREAM Ultra (1920 Wh) + 2 EcoFlow STREAM CA Pro (1920 Wh)',
            tips: '',
            save: 'Ahorra hasta 286 € cada año',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854799707&purchaseOption=693334802779',
            descList: ['96%', '1983 kWh ', '1977 kg'],
        },
    ],
};
